/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ClaimChecker from "./ClaimChecker";
import ClaimResult from "./ClaimResult";
import { fetchClaimData, fetchClaimById } from "../api/claimCheck";

export default function ClaimPage() {
  const [resultData, setResultData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { searchId } = useParams(); // Get searchId from URL parameters
  const navigate = useNavigate();

  // Function to fetch claim by ID
  const fetchClaimByIdHandler = async (id) => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await fetchClaimById(id);
      
      // Check if there's an error in the response
      if (data?.error) {
        throw new Error(data.message || "Failed to fetch claim");
      }
      
      if (!data || !data.result) {
        throw new Error("Claim not found or invalid data returned");
      }
      
      setResultData(data.result);
    } catch (err) {
      setError(err.message);
      // Reset resultData to return to claim check page
      setResultData(null);
    } finally {
      setIsLoading(false);
    }
  };

  // Check if there's a searchId in the URL and fetch the corresponding claim
  useEffect(() => {
    if (searchId) {
      fetchClaimByIdHandler(searchId);
    }
  }, [searchId]);

  const handleClaimSubmit = async (claimText) => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await fetchClaimData(claimText);
      
      // Handle validation errors from API
      if (data?.error) {
        if (data.type === "validation") {
          // Set the error with the message from backend
          throw new Error(data.message || "Invalid claim text");
        } else {
          throw new Error(data.message || "API request failed");
        }
      }

      if (!data || !data.result) {
        throw new Error("API request failed or returned invalid data");
      }

      setResultData(data.result);
    } catch (err) {
      console.error("Error submitting claim:", err);
      setError(err.message);
      // Reset resultData to ensure we're on the claim check page
      setResultData(null);
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading state
  if (isLoading) {
    return (
      <div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>
            A.I. is Analyzing your Political Claim against Parliament Records...
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {!resultData ? (
        <div className="claim-checker-container">
          {/* Compact error banner that matches the existing alert in your screenshot */}
          {error && (
            <div 
              style={{
                backgroundColor: "#ffebee",
                color: "#d32f2f",
                border: "1px solid #ffcdd2",
                borderRadius: "4px",
                padding: "10px 16px",
                margin: "0 auto 20px",
                maxWidth: "600px",
                textAlign: "center",
                fontSize: "0.9rem"
              }}
            >
              {error}
            </div>
          )}
          <ClaimChecker onSubmitClaim={handleClaimSubmit} />
        </div>
      ) : (
        <ClaimResult
          resultData={resultData}
          claim={resultData.speech_verdict?.claim_analyzed}
          verdict={resultData.overall_verdict}
          records={resultData.speech_verdict.individual_speech_analyses}
          speech_stats={
            resultData.speech_verdict.overall_speech_analysis_summary
          }
          vote_stats={resultData.vote_verdict.stats}
          counts={resultData.counts}
          speechEvidenceData={
            resultData.speech_verdict.individual_speech_analyses
          }
          vote_records={resultData.vote_verdict.division_list}
          searchId={searchId ? searchId : resultData.search_id}
          setResultData = {setResultData}
        />
      )}
    </>
  );
}